import { Action } from 'redux';

import { RequestStatus } from './request';

export interface ICreateUser {
  firstName: string;
  lastName: string;
  institution: string;
  email: string;
}

export const CREATE_USER = 'CREATE_USER';
export const CREATED_USER = 'CREATED_USER';
export const CREATING_USER = 'CREATING_USER';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';

export interface ICreateUserFailed {
  type: typeof CREATE_USER_FAILED;
  payload: JSX.Element | undefined;
}

interface CreateUser extends Action {
  type: typeof CREATE_USER;
  payload: JSX.Element | undefined;
}

interface CreatedUser extends Action {
  type: typeof CREATED_USER;
  payload: undefined;
}

interface CreatingUser extends Action {
  type: typeof CREATING_USER;
  payload: undefined;
}
export interface CreateUserState {
  status: RequestStatus;
  error?: JSX.Element;
}

export type CreateUserActionTypes =
  | ICreateUserFailed
  | CreatedUser
  | CreatingUser
  | CreateUser;
